import * as z from 'zod'
import { CarRental } from '~/shared/api'
import {
  innCiRequiredSchema,
  ogrnCiRequiredSchema,
  phoneScheme,
} from '~/shared/lib/schemas'

const baseSchema = CarRental.schema.pick({
  name: true,
  fullName: true,
  legalAddress: true,
  actualAddress: true,
  directorPosition: true,
  directorFio: true,
  email: true,
  webSite: true,
  authorizedCapital: true,
})

export const formSchema = baseSchema.and(
  z.object({
    phoneNumber: phoneScheme,
    inn: innCiRequiredSchema,
    ogrn: ogrnCiRequiredSchema,
  }),
)

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = TypeFormSchema
